import type React from 'react';
import { useEffect } from 'react';

export const useIntersectionObserver = (
  target: React.RefObject<Element>,
  callback: (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => void,
  options: IntersectionObserverInit,
) => {
  useEffect(() => {
    const tagetCur = target.current;
    if (!tagetCur) {
      return;
    }
    const observer = new IntersectionObserver(callback, options);
    observer.observe(tagetCur);

    return () => {
      if (tagetCur) {
        observer.unobserve(tagetCur);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, target.current]);
};
